export default "__VITE_ASSET__51b84932__"